import { action } from 'src/store/actions';

export const FETCH_USERS = 'FETCH_USERS';
export const REQUEST_USERS = 'REQUEST_USERS';
export const SUCCESS_USERS = 'SUCCESS_USERS';
export const FAILURE_USERS = 'FAILURE_USERS';

export const fetchUsers = (query: string) => action(FETCH_USERS, { query });
export const requestUsers = () => action(REQUEST_USERS);
export const requestUsersSuccess = (response: any) => action(SUCCESS_USERS, { response });
export const requestUsersFailure = (error: any) => action(FAILURE_USERS, { error });
